import React, {Fragment, useEffect, useState} from 'react'
import {Carousel} from 'antd'

export default function DigitalScrolling(props) {
    let {num} = props
    const [strList, setStrList] = useState([]);
    const [domList, setDomList] = useState([])


    useEffect(() => {
        let strList = num ? num.toString().split('') : []
        let domList = []
        strList.forEach(item => {
            domList.push(null)
        })
        setStrList(strList)
        setDomList(domList)

    }, [props.num])

    useEffect(() => {
        strList.forEach((item, i) => {
            domList[strList.length - 1 - i].goTo(item)
        })
    }, [domList])

    const returnComma = (index) => {
        if (index !== strList.length - 1 && (strList.length - 1 - index) % 3 === 2 && index !== 0) {
            return <div className='Guide_TopCarousel_right_num'>,</div>; // 或者使用其他方式表示逗号，比如返回字符串 ','
        }
        return null;
    }

    return (
        <div className='Guide_TopCarousel_right_num_wrap'>
            {strList.length > 0 && strList.map((item, i) => {
                return (
                    <>
                        {returnComma(i)}
                        <Carousel dotPosition='right' dots={false} ref={ref => domList[strList.length - 1 - i] = ref}>
                            <div className='Guide_TopCarousel_right_num'>0</div>
                            <div className='Guide_TopCarousel_right_num'>1</div>
                            <div className='Guide_TopCarousel_right_num'>2</div>
                            <div className='Guide_TopCarousel_right_num'>3</div>
                            <div className='Guide_TopCarousel_right_num'>4</div>
                            <div className='Guide_TopCarousel_right_num'>5</div>
                            <div className='Guide_TopCarousel_right_num'>6</div>
                            <div className='Guide_TopCarousel_right_num'>7</div>
                            <div className='Guide_TopCarousel_right_num'>8</div>
                            <div className='Guide_TopCarousel_right_num'>9</div>
                        </Carousel>
                    </>
                )
            })}
        </div>
    )
}